
import pluralize from 'pluralize'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { mapGetters } from 'vuex'
import AddToFolderTree from './AddToFolderTree'
import CreateNewFolderControl from './CreateNewFolderControl'
import ButtonRoundGreen from '~/components/Buttons/ButtonRound/ButtonRoundGreen'
import ui from '~/ZenOne-StoryBook/mixins/ui'
import { isArrayWithLength } from '~/ZenOne-StoryBook/helpers/types'
import request from '~/components/Inventory/mixins/request'

export default {
  name: 'AddToFolderDialog',
  components: {
    CreateNewFolderControl,
    AddToFolderTree,
    ButtonRoundGreen,
    vueCustomScrollbar,
  },
  mixins: [ui, request],
  props: {
    isCatalog: {
      type: Boolean,
      default: false,
    },
    counter: {
      type: Number,
      default: 1,
    },
    selectedList: {
      type: Array,
      default() {
        return []
      },
    },
    initialFolderId: {
      type: Number,
      default: null,
    },
    productDistributorId: {
      type: Number,
      default: null,
    },
    withRootItem: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      destinationFolderId: this.initialFolderId,
      dialog: false,
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      foldersTree: 'inventory/foldersTree',
      folderId: 'inventory/folderId',
    }),
    items() {
      const { foldersTree = [] } = this
      if (this.withRootItem) return foldersTree
      return foldersTree?.[0]?.children ?? []
    },
    hasNoFoldersInTree() {
      return !isArrayWithLength(this.items)
    },
    showNoFoldersMsg() {
      return !this.productDistributorId && this.hasNoFoldersInTree
    },
    hasProductDistributor() {
      const { productDistributorId = null } = this
      return !!productDistributorId && Number.isInteger(productDistributorId)
    },
    hasInitialFolderId() {
      const { initialFolderId = null } = this
      return !!initialFolderId && Number.isInteger(initialFolderId)
    },
    isAddingProductToFolder() {
      return this.hasProductDistributor && !this.hasInitialFolderId
    },
    isMovingProductToFolder() {
      return this.hasProductDistributor && this.hasInitialFolderId
    },
    isMyInventoryAction() {
      return !this.hasProductDistributor
    },
    isActionBtnDisabled() {
      const { destinationFolderId = null } = this
      return (
        this.isLoading ||
        this.hasNoFoldersInTree ||
        this.isFSLoaderShow ||
        !destinationFolderId ||
        (!this.isCatalog && this.folderId === destinationFolderId)
      )
    },
    actionBtnText() {
      return `Add (${this.counter} ${pluralize('item', this.counter)})`
    },
    pluralizedProduct() {
      return pluralize('product', this.counter)
    },
  },
  watch: {
    dialog: {
      handler(value) {
        if (value) return false
        this.destinationFolderId = null
      },
    },
  },
  methods: {
    show() {
      this.dialog = true
    },
    close() {
      this.$emit('on-close-add-to-inventory-dialog')
      this.destinationFolderId = null
      this.dialog = false
    },
    closeBtnClickHandler() {
      this.close()
    },
    onSetDestinationFolderId({ folderId = null }) {
      this.destinationFolderId = folderId
    },
    async actionBtnClickHandler() {
      this.isLoading = true
      const { productDistributorId = null, destinationFolderId = null } = this
      if (this.isAddingProductToFolder) {
        await this.addProductToFolder(productDistributorId, destinationFolderId)
      } else if (this.isMyInventoryAction || this.isMovingProductToFolder) {
        await this.moveToFolder(
          this.selectedList,
          destinationFolderId,
          productDistributorId
        )
      }
      this.isLoading = false
    },
  },
}
